import React, { useRef, useState, useEffect, useContext, useMemo } from "react";
import { ThemeContext } from 'styled-components';
import * as S from "./FlorenzSelect.style.js";
import { ZaiaImage } from "../../zaiaComponents/zaiaImage/ZaiaImage.style.js";

const defaultDoctor = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaImgDefault/default-doctor.png`;

function FlorenzSelect({ 
  placeholder,
  xsSize,
  forWhiteBackgroud=true, 
  label,
  patientsList=[],
  icon,
  items= [],
  value,
  setValue,
  disabled,
  heightList,
  required,
  selectionText,
  noDropdown
}) {

  const container = useRef(null);
  const [listActive, setlistActive] = useState(false);
  const textInput = useRef(null);
  const theme = useContext(ThemeContext);

  useEffect(() => {
    const handleClickOutside = e => {
      if (!container.current.contains(e.target)) {
        setlistActive(false)
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function handleChange(item) {
    setValue(item)
    setlistActive(false);
  }

  const itemList = useMemo(() => {    
    return patientsList.length > 0 ? patientsList : items;
  }, [patientsList, items]);

  return (
    <S.FlorenzSelect 
      xsSize={xsSize}
      listActive={listActive}
      disabled={disabled}
      forWhiteBackgroud={forWhiteBackgroud}
      heightList={heightList}
      value
      patientsList
      icon
      required={required}
    >
      <div onClick={(e) => {}} ref={container}>
        <div className="input-container" onClick={
          (e) => {
            if(!disabled) {
              textInput.current.focus(); 
              setlistActive(e);
            }
          }
        }>
          {
            (patientsList.length > 0 || icon || disabled) &&
            <div className="icon-input-form">
              {
                (!disabled && value) &&
                <ZaiaImage 
                  img={
                    patientsList?.find( patient => patient.value === value)?.img 
                      ? patientsList?.find( item => item.value === value)?.text 
                      : ''
                  } 
                  alt="Zaia User" 
                  size={xsSize ? 34 : 17} 
                  defaultImg={defaultDoctor} 
                  rounded={true}
                /> 
              }              
              <i className={
                  disabled 
                  ? 'icon-input-form__icon icon zaia-i-lock-chat'
                  : (patientsList.length > 0 && !value)
                    ? "icon-input-form__icon icon zaia-i-patient"
                    : icon 
                      ? icon
                      : null
                }
              />
            </div>
          }
          
          <div className="text-info">
            {label && <div className={`label ${(!value && !placeholder) ? 'label--no-margin' : ''}`}>
              <div className="label__text">{label}</div>
              {
                required &&
                <div className="label__icon">{
                  value
                  ? <i className="label__icon-icon icon zaia-i-check-1"></i>
                  : <div className="label__icon-required error">*</div>
                }</div>
              }
            </div>}
            {
              <input 
                ref={textInput}
                value={
                  selectionText
                  ? selectionText
                  : itemList?.find( item => item.value === value)?.text 
                    ? itemList?.find( item => item.value === value)?.text 
                    : ''
                }
                placeholder={placeholder}
                readOnly
                style={{ display: value || placeholder ? 'flex' : 'none' }}
              />
            }
          </div>
          <div className="input-icon-arrow">
            <i className={'icon-input-form-arrow icon zaia-icono-dropdown-light'} />
          </div>
        </div>
        <div className="select-list">
          {
            (disabled || noDropdown)
            ? null
            : itemList?.map(item => {
              return (
                <div className="select-item" key={item.value} onClick={() => handleChange(item.value)}>
                  <label>{item.text} </label>
                </div>
              )
            })
          }
        </div>
      </div>
    </S.FlorenzSelect>
  );
}

export default FlorenzSelect;
